// extracted by mini-css-extract-plugin
export default {"wrap":"qxnxl8TMZZVtNIywtYqi"};